import React, { useEffect } from 'react';

// Legacy signup is retired. All new signups now go through the single web-app
// signup (one source of truth) — see the 2026-06 billing overhaul. Anyone who
// lands on old.sparkapt.com/signup (or any in-app "Sign up" link, which all
// route here) is forwarded to the new signup. Keep the default export named
// `Registration` so the `@website` barrel + the /signup route resolve unchanged.
//
// Preserve the query string: legacy signup is now affiliate-code-only, so the
// only real traffic is /signup?code=<affiliate>. The web signup reads the SAME
// `?code=` param for referral attribution, so we forward it verbatim.
const NEW_SIGNUP_URL = 'https://sparkapt.com/signup';

export default function Registration() {
  const search = typeof window !== 'undefined' ? window.location.search : '';
  const target = NEW_SIGNUP_URL + search;

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        fontFamily: 'sans-serif',
        textAlign: 'center',
        padding: 24,
      }}
    >
      <p style={{ fontSize: 16, color: '#334155', margin: 0 }}>Taking you to sign up…</p>
      <a href={target} style={{ fontSize: 14, color: '#2563eb' }}>
        Continue to sign up
      </a>
    </div>
  );
}
